import React from 'react'
import "../trinetra.css"
import { useNavigate } from 'react-router';
import 'bootstrap/dist/css/bootstrap.min.css';
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import OpenInBrowserRoundedIcon from '@mui/icons-material/OpenInBrowserRounded';
import logo from  '../../../assets/img/3rdEyeAIsvg.png'




export default function TopNavBar(props) {

  console.log("fff : ",props.disableBackBtn);
    const navigate = useNavigate()
    const backButton = () => {
        if(props.toRender.length<2){
          return;
        }
        props.toRender.pop();
        props.setToRender(props.toRender);
        props.toggleRenderTrigger(!props.renderTrigger);
      }
  return (
        <div className='row'>
        <header className='logo'>
        {!props.disableBackBtn ? <div className='col-lg-4 float button-box-left'><button onClick={backButton}><KeyboardBackspaceRoundedIcon/>&nbsp;&nbsp;&nbsp;back</button></div> : <div className='col-lg-4 float button-box-left'></div>}
            <div className='col-lg-4 float'><img src={logo} width="20%"/></div>
            <div className='col-lg-4 float button-box-right'><a href='https://third-eye.ai/' target={"_blank"}><button type='button'>Visit Website&nbsp;&nbsp;&nbsp;<OpenInBrowserRoundedIcon/></button></a></div>
        </header>
      </div>
  )
}
